import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { View } from 'react-native';
import { styles } from './SavedButton.styles';
import { Alerts } from 'src/theme-v2/colors';
import { TooltipPosition } from '@photosi/rn-components/tooltips/Tooltip.types';
import { TestIDs } from 'src/constants/testIDs.constants';
import { BasePressTooltip } from '@photosi/rn-components/tooltips/base-press-tooltip/BasePressTooltip';
import { ProjectSaveButtonProps } from '../ProjectSaveButton.types';
import { BaseHoverTooltip } from '@photosi/rn-components/tooltips/base-hover-tooltip/BaseHoverTooltip';
import { getTimeAndDateInfo } from 'src/helpers/time.helper';
import { useTooltipContext } from '@photosi/rn-components/tooltips/tooltip-provider/TooltipContext';
import { useCallback, useEffect, useState } from 'react';
import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { headerEditorTestID } from 'src/helpers/testIDs.helper';
import { PressTooltipContent } from './press-tooltip-content/PressTooltipContent';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
export const SavedButton = ({
  i18n,
  lastSaveTimestamp,
  isPressTooltipEnabled,
  focusGroup,
  focusOrder,
}: ProjectSaveButtonProps) => {
  const { closeTooltip } = useTooltipContext();
  const [isPressTooltipVisible, setIsPressTooltipVisible] = useState(false);

  const HoverTooltipContent = useCallback(() => {
    const timeAndDateInfo = getTimeAndDateInfo(lastSaveTimestamp);
    return timeAndDateInfo ? (
      <TextLato style={styles.hoverTooltipContentWrapper}>
        {i18n.t('tooltip-save-project:last-save_date_hour', timeAndDateInfo)}
      </TextLato>
    ) : (
      <></>
    );
  }, [lastSaveTimestamp]);

  const TooltipButton = useCallback(
    ({ isContentVisible, ...props }: { isContentVisible: boolean; [key: string]: any }) => {
      useEffect(() => {
        setIsPressTooltipVisible(isContentVisible);
      }, [isContentVisible]);

      return (
        <BaseButton
          {...props}
          style={styles.tooltipButtonPressable}
          focusId={headerEditorTestID(TestIDs.SAVED, 'button')}
          focusOrder={focusOrder}
          focusGroup={focusGroup}
        >
          {() => (
            <View style={[styles.tooltipButton, isContentVisible && styles.tooltipButtonActive]}>
              <TextLato style={styles.tooltipButtonText}>{i18n.t('header:project-saved')}</TextLato>
              <Icon name={ICON_NAMES.Check} width={16} height={16} color={Alerts.Green500} />
            </View>
          )}
        </BaseButton>
      );
    },
    [i18n],
  );

  return (
    <BaseHoverTooltip
      tooltipID={`${TestIDs.TOOLTIP_SAVE_PROJECT}-hover`}
      TooltipContent={HoverTooltipContent}
      containerStyle={styles.hoverTooltipContainer}
      disabled={isPressTooltipVisible}
    >
      {isPressTooltipEnabled ? (
        <BasePressTooltip
          onPress={closeTooltip}
          containerStyle={styles.pressTooltipContainer}
          TooltipContent={tooltipContentProps => (
            <PressTooltipContent
              {...tooltipContentProps}
              focusGroup={FocusGroups.TOOLTIP}
              focusOrder={0}
              focusId={headerEditorTestID(TestIDs.SAVED, 'tooltip')}
            />
          )}
          position={TooltipPosition.BOTTOM}
          tooltipID={`${TestIDs.TOOLTIP_SAVE_PROJECT}-press`}
          TooltipButton={TooltipButton}
          showTooltipArrow
        />
      ) : (
        <TooltipButton isContentVisible={false} />
      )}
    </BaseHoverTooltip>
  );
};
